import { defineComponent, ref, watch } from 'vue'
import { useFilterStore } from '@/store/filter'
import { useServicesStore } from '@/store/services'

export default defineComponent({
  name: 'ServiceCategoriesFilter',
  emits: ['closePopup'],
  setup(_, { emit }) {
    const currentActive = ref<null | 1 | 0>(null)
    const servicesStore = useServicesStore()
    const filterStore = useFilterStore()

    const changeActive = (value: 1 | 0) => {
      currentActive.value = value
      filterStore.setFilterItem('active', {
        title: 'Активность',
        name: value ? 'Да' : 'Нет',
        value,
      })
    }

    const applyFilter = async () => {
      await servicesStore.applyFilter(
        {
          search: filterStore.filters.search,
          isActive:
            currentActive.value !== null ? !!filterStore.filters.selected?.active?.value : '',
        },
        'category',
      )
      filterStore.isSend = false
      emit('closePopup')
    }

    const clearFilter = async () => {
      filterStore.clearFilter()
      await servicesStore.clearFilter('category')
    }

    watch(
      () => filterStore.filters?.selected?.active,
      (value, oldValue) => {
        if (oldValue && !value) {
          currentActive.value = null
        }
      },
      { deep: true },
    )

    watch(
      () => filterStore.isSend,
      async newVal => {
        if (newVal) {
          await applyFilter()
        }
      },
    )

    return { currentActive, changeActive, applyFilter, clearFilter }
  },
})
